/* Component Dependencies */
var spaServiceAndOfferingsTemplate = require('templates/spa-servicesAndOfferings.hbs');
var spaLocalAreaTemplate = require('templates/spa-localArea.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'spa',
    template: {
        'spa-servicesAndOfferings': spaServiceAndOfferingsTemplate,
        'spa-localArea': spaLocalAreaTemplate
    }
});